// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-25T19:52:29.311Z
// Property: Heritage at Deer Valley (ID: 6767906449166434)
// Collections: 26 amenities, 17 floorplans (live), 22 photos, 50 POIs, 1 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166434",
  "property_external_id": "3jc6g2d",
  "property_zillow_url": "https://www.zillow.com/apartments/phoenix-az/heritage-at-deer-valley/5XhyP6/",
  "property_apartments_url": "https://www.apartments.com/the-heritage-at-deer-valley-phoenix-az/3jc6g2d/",
  "property_google_business_url": "https://www.google.com/maps/place/Heritage+at+Deer+Valley/data=!4m2!3m1!1s0x0:0xd2bb675968ad0715?sa=X&ved=2ahUKEwiiosmk4qeSAxVgZvUHHZIjHmYQ_BJ6BAgNEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40245962057",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "93HDV",
  "property_status": null,
  "property_slug": "heritage-at-deer-valley",
  "property_name": "Heritage at Deer Valley",
  "property_website_url": "https://www.heritageatdeervalley.com/",
  "property_domain": "https://www.heritageatdeervalley.com/",
  "property_address": "3010 West Yorkshire Drive",
  "property_full_address": "3010 W Yorkshire Dr, Phoenix, AZ 85027, USA",
  "property_address_1": "3010 West Yorkshire Drive",
  "property_address_2": null,
  "property_address_city": "Phoenix",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85027",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Deer Valley",
  "property_address_latitude": "33.6634169",
  "property_address_longitude": "-112.1243215",
  "property_email": null,
  "property_phone": "8443213908",
  "property_call_tracking_phone": "844-887-9366",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Heritage at Deer Valley, where spacious living meets premier amenities in sunny Phoenix, AZ. Choose from one-, two-, or three-bedroom floor plans featuring wood-style plank flooring, expansive walk-in closets, and private balconies. Enjoy resort-style pools, a bark park, and fitness facilities—your perfect sanctuary awaits! Schedule a tour today!",
  "property_long_description": "Heritage at Deer Valley redefines upscale apartment living with elegant one-, two-, and three-bedroom residences designed for comfort, style, and space. Set within Phoenix’s sought-after Deer Valley neighborhood, the community blends refined interiors with resort-inspired amenities to create a lifestyle that feels both elevated and effortless.\n\nEach apartment home features open-concept floor plans, high ceilings, and private patios or balconies, offering an airy, sophisticated atmosphere. Thoughtfully curated details such as spacious walk-in closets, in-home washers and dryers, and select upgraded finishes bring everyday luxury into focus—perfect for both relaxing and entertaining.\n\nBeyond the front door, residents enjoy a collection of resort-style amenities designed to enhance daily living. Spend sunny Arizona afternoons at one of three sparkling swimming pools with spa, recharge in the two fully equipped fitness centers or yoga studio, or gather with friends at the outdoor grilling and picnic areas. Pet owners appreciate the pet-friendly community, complete with a dog park, while conveniences such as covered parking, garages, and a welcoming clubhouse complete the experience.\n\nIdeally located near Deer Valley Towne Center, major employers, and Phoenix’s top dining and entertainment options, Heritage at Deer Valley also offers seamless access to Loop 101 and I-17, keeping the entire Valley within reach.\n\nAt Heritage at Deer Valley, luxury is more than a feature—it’s a way of life.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f6b9a-b563-756a-81e6-9f3cfd71696e.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "019f6b9a-b563-756a-81e6-9f3cfd71696e",
    "storage_key": "property/6767906449166434/019f6b9a-b563-756a-81e6-9f3cfd71696e.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166434/019ffc39-c0b4-75f3-9369-303479a4f1c3.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc39-c0b4-75f3-9369-303479a4f1c3",
    "storage_key": "property/6767906449166434/019ffc39-c0b4-75f3-9369-303479a4f1c3.m4v",
    "thumbnail_key": "property/6767906449166434/019ffc39-c0b4-75f3-9369-303479a4f1c3_thumb.webp",
    "size_bytes": 15477173,
    "classification": "Community",
    "title": "Explore Our Apartment Community's Amenities and Interiors",
    "description": "Discover the features of our apartment community, including stylish interiors, a dog park, grilling areas, and inviting common spaces."
  },
  "property_total_units": "832",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.4326923076923",
  "property_admin_fee": "385",
  "property_application_fee": "75",
  "property_fees_deposit_info": "500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "600",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "60",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs are welcome. One-time pet fee: $600 per pet. Monthly pet rent: $60 per cat or dog. Maximum of 2 pets per unit. Breed restrictions apply. ",
  "property_petpolicy_info": "Cats and dogs are welcome. One-time pet fee: $600 per pet. Monthly pet rent: $60 per cat or dog. Maximum of 2 pets per unit. Breed restrictions apply. ",
  "property_online_leasing_url": "https://myrentalapplication.com/index/amcheritageatdeervalley",
  "property_resident_portal_url": "https://heritageatdeervalley.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcheritageatdeervalley",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02cb-c87b-71ae-aaae-73da31d37e91.webp",
  "property_primary_logo_media": {
    "alt_text": "Heritage at Deer Valley logo",
    "public_id": "019d02cb-c87b-71ae-aaae-73da31d37e91",
    "storage_key": "property/6767906449166434/019d02cb-c87b-71ae-aaae-73da31d37e91.webp",
    "width": 230,
    "height": 119
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02cb-b348-73ad-8177-be486c1ea784.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02cb-b348-73ad-8177-be486c1ea784",
    "storage_key": "property/6767906449166434/019d02cb-b348-73ad-8177-be486c1ea784.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02cb-d3a3-733f-a2fc-c4a5656c932b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Heritage at Deer Valley logo",
    "public_id": "019d02cb-d3a3-733f-a2fc-c4a5656c932b",
    "storage_key": "property/6767906449166434/019d02cb-d3a3-733f-a2fc-c4a5656c932b.webp",
    "width": 230,
    "height": 119
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02cb-c87b-71ae-aaae-73da31d37e91.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Heritage at Deer Valley logo",
    "public_id": "019d02cb-c87b-71ae-aaae-73da31d37e91",
    "storage_key": "property/6767906449166434/019d02cb-c87b-71ae-aaae-73da31d37e91.webp",
    "width": 230,
    "height": 119
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": "#06313f",
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "658 - 1,293 sq ft",
  "property_sqft_min": "658",
  "property_sqft_max": "1,293",
  "property_price_range": "$1102 - $1769",
  "property_price_min": "1102",
  "property_price_max": "1769",
  "property_available_units": 38,
  "property_facebook_url": "https://www.facebook.com/HeritageatDeerValley/photos/",
  "property_instagram_url": "https://www.instagram.com/heritage_at_deer_valley1/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJSxxkkW9vK4cRFQetaFlnu9I",
  "property_youtube_url": "https://www.youtube.com/watch?v=n2m8nTDWQfw",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Phoenix%2C+AZ&start=60",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Heritage at Deer Valley",
  "property_home_romance_title": "Embrace Life’s Joys in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "Welcome to Heritage at Deer Valley, where vibrant living meets comfort in the heart of Phoenix, AZ. Enjoy spacious floor plans designed for your lifestyle, complemented by resort-style amenities like multiple swimming pools, a relaxing spa, and a fun-filled bark park. Luxury and convenience await—your new home is here!",
  "property_home_floorplans_blurb": "At Heritage at Deer Valley in Phoenix, AZ, your ideal apartment home awaits! With diverse floor plans designed for comfort and style, each space reflects modern living. Browse our available options and envision your future in a community that embraces both relaxation and vibrant city life. ",
  "property_home_gallery_blurb": "At Heritage at Deer Valley in Phoenix, AZ, experience the perfect blend of luxury and comfort. Enjoy spacious floor plans, serene private terraces, and resort-style amenities, including three sparkling pools and a dog-friendly bark park. Picture yourself living here, where every detail caters to your lifestyle needs.",
  "property_home_neighborhood_blurb": "At Heritage at Deer Valley, comfort meets convenience in vibrant Phoenix. Choose from spacious one, two, or three-bedroom floor plans while enjoying a dynamic neighborhood filled with cultural gems. With proximity to Arizona State University and serene parks like Thunderbird Conservation Park, your ideal lifestyle awaits just beyond your front door.",
  "property_home_reviews_blurb": "Welcome to Heritage at Deer Valley, where exceptional living meets stunning Phoenix landscapes. Our residents rave, “The sense of community here is unmatched!” Immerse yourself in vibrant amenities and a welcoming atmosphere. Curious about what makes us home? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Phoenix, Heritage at Deer Valley offers a vibrant lifestyle surrounded by premier recreational spots and educational institutions. Enjoy easy access to the Sonoran Preserve for outdoor adventures, the cultural allure of the Martin Auto Museum, and the excitement at Hurricane Harbor. Experience your next chapter here!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience the vibrant lifestyle at Heritage at Deer Valley in Phoenix, AZ. Indulge in resort-style pools, unwind at the spa, or enjoy a fun game at the sand volleyball courts. With spacious floor plans and pet-friendly amenities, your dream home awaits. Elevate your living experience today!",
  "property_applynow_blurb": "At Heritage at Deer Valley in Phoenix, AZ, enjoy spacious living with one, two, and three-bedroom floor plans. With resort-style pools, a fitness club, and a pet-friendly bark park, every day feels like a getaway. Secure your spot and lease online today—your oasis awaits!",
  "property_contactus_blurb": "At Heritage at Deer Valley in sunny Phoenix, AZ, find your perfect living space among our thoughtfully designed one, two, and three-bedroom floor plans. Each home is a blend of comfort and style, tailored to your needs. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Heritage at Deer Valley in Phoenix, AZ, our diverse floor plans—from cozy one-bedroom to spacious three-bedroom apartments—cater to every lifestyle. Have questions? Our FAQs page provides insights tailored to your needs. Unearth the information that makes your living experience seamless and enjoyable! ",
  "property_floorplans_blurb": "At Heritage at Deer Valley in sunny Phoenix, AZ, a variety of thoughtfully designed floor plans await you. From cozy one-bedroom retreats to spacious three-bedroom havens, every layout caters to your unique lifestyle. Browse our available apartment homes and unveil the perfect sanctuary that resonates with your dreams.",
  "property_gallery_blurb": "At Heritage at Deer Valley, you’ll find spacious one, two, and three-bedroom apartments designed for your comfort. Enjoy resort-style amenities like three sparkling pools, a relaxing spa, and vibrant BBQ areas. With easy freeway access, your picture-perfect lifestyle awaits. Imagine the possibilities—this is where your next chapter begins!",
  "property_interactivemap_blurb": "At Heritage at Deer Valley in Phoenix, AZ, indulge in spacious living with a variety of modern floor plans, from one to three bedrooms. Enjoy top-tier amenities like resort-style pools, a relaxing spa, and a vibrant bark park. Your perfect home awaits—use our interactive community map to start your journey!",
  "property_pets_blurb": "At Heritage at Deer Valley in Phoenix, AZ, your furry friends can join you in your stylish abode. With a welcoming pet policy that allows up to two pets, your cats and dogs will thrive amidst our vibrant community. Embrace a lifestyle where comfort meets companionship!",
  "property_referafriend_blurb": "At Heritage at Deer Valley in Phoenix, AZ, a vibrant community awaits! Choose from spacious one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Great friends make great neighbors—invite your pals to share the joy of luxury living with us today! Join our welcoming family and thrive together!",
  "property_residentaccess_blurb": "Welcome to Heritage at Deer Valley in sunny Phoenix, AZ! Enjoy a range of thoughtfully designed floor plans—one, two, and three-bedroom options tailored to your lifestyle. Access your resident portal for hassle-free rent payments, maintenance requests, and community updates. Elevate your living experience today!",
  "property_reviews_blurb": "At Heritage at Deer Valley in Phoenix, AZ, residents rave about the sense of community and exceptional service. One satisfied resident shares, “The staff truly cares about our well-being, creating a warm, welcoming atmosphere.” See what our residents have to say about living at our community and join today!",
  "property_created_at": "1759782557060",
  "property_scheduletour_blurb": "At Heritage at Deer Valley in Phoenix, AZ, each thoughtfully designed floor plan—whether one, two, or three bedrooms—offers a unique sanctuary to call home. Experience a vibrant community where comfort meets convenience. Schedule a tour today and hear firsthand how our residents embrace the Heritage lifestyle!",
  "property_thankyou_blurb": "Thank you for reaching out to Heritage at Deer Valley in vibrant Phoenix, AZ! Our diverse floor plans, including one, two, and three-bedroom options, cater to your lifestyle. A team member will connect with you soon to help you find your perfect home in our welcoming community.",
  "property_virtualtours_blurb": "Welcome to Heritage at Deer Valley, where your dream living space awaits! Nestled in vibrant Phoenix, AZ, our one, two, and three-bedroom apartments blend comfort with style. Experience a glimpse of your future home—take a virtual tour of our exquisite community today! Your perfect apartment is just a click away!",
  "property_copyright": "2025 All Rights Reserved. Heritage at Deer Valley",
  "property_seo_title_home": "Heritage at Deer Valley |  Apartments in Phoenix, AZ",
  "property_seo_description_home": "Experience resort-style living at Heritage at Deer Valley! Choose from spacious 1 to 3-bedroom apartments with top-notch amenities. Your dream home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Apartments in North Phoenix, AZ",
  "property_seo_description_floorplans": "Discover your perfect home at Heritage at Deer Valley in Phoenix, AZ! Choose from stylish one, two, or three-bedroom apartments. Browse now!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments in North Phoenix, AZ",
  "property_seo_description_amenities": "Elevate your lifestyle at Heritage at Deer Valley! Enjoy resort-style pools, a bark park, spacious floor plans, and more. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Deer Valley, AZ",
  "property_seo_description_gallery": "Discover life at Heritage at Deer Valley, Phoenix: resort-style pools, spacious layouts, and pet-friendly areas—all waiting for you!",
  "property_seo_title_virtualtours": "Virtual Tours | Apartment Complexes in Phoenix, AZ",
  "property_seo_description_virtualtours": "Step inside Heritage at Deer Valley in Phoenix, AZ! Take a virtual tour and envision your perfect one, two, or three-bedroom apartment today!",
  "property_seo_title_interactivemap": "Thank You | Apartments in Phoenix, AZ",
  "property_seo_description_interactivemap": "Thank you for contacting Heritage at Deer Valley! We value your inquiry and will be in touch soon to assist with your new home in Phoenix!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments for Rent in Deer Valley, AZ",
  "property_seo_description_neighborhood": "Explore the vibrant neighborhood around Heritage at Deer Valley in Phoenix, AZ, with parks, favorites, and entertainment just steps away!",
  "property_seo_title_contact": "Contact Us | Apartments in North Phoenix, AZ",
  "property_seo_description_contact": "Connect with the Heritage at Deer Valley team in Phoenix, AZ! Whether seeking a one, two, or three-bedroom apartment, we're here to help with your inquiries.",
  "property_seo_title_faqs": "Virtual Tours | Apartments in Phoenix, AZ",
  "property_seo_description_faqs": "Step inside Heritage at Deer Valley in Phoenix, AZ! Take a virtual tour and envision your perfect one, two, or three-bedroom apartment today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Phoenix, AZ",
  "property_seo_description_reviews": "Join our vibrant community at Heritage at Deer Valley in Phoenix! Discover spacious homes, resort-style amenities, and a welcoming atmosphere!",
  "property_seo_title_applynow": "Apply Now | Apartment Complexes in Phoenix, AZ",
  "property_seo_description_applynow": "Discover your perfect home at Heritage at Deer Valley, Phoenix! Explore spacious layouts, resort-style amenities, and a vibrant community!",
  "property_seo_title_residentaccess": "Apply Now | Apartments in Phoenix, AZ",
  "property_seo_description_residentaccess": "Discover life at Heritage at Deer Valley, Phoenix! Choose from spacious 1-3 bedroom apartments with resort-style amenities. Lease online now!",
  "property_seo_title_referafriend": "Refer A Friend | Heritage at Deer Valley",
  "property_seo_description_referafriend": "Refer friends to Heritage at Deer Valley and share the joy of vibrant living in Phoenix. Great friends make the best neighbors—join our community today!",
  "property_seo_title_scheduletour": "Schedule a Tour |  Apartments in Deer Valley, AZ",
  "property_seo_description_scheduletour": "Experience the charm of Heritage at Deer Valley in Phoenix, AZ. Schedule a tour today and find your ideal home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Heritage at Deer Valley",
  "property_seo_description_privacy": "At Heritage at Deer Valley in Phoenix, AZ, your privacy matters. Uncover our commitment to safeguarding your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Heritage at Deer Valley",
  "property_seo_description_accessibility": "Discover seamless living at Heritage at Deer Valley, Phoenix, AZ, where our accessibility statement emphasizes our commitment to digital inclusion!",
  "property_seo_title_sitemap": "Sitemap | Heritage at Deer Valley",
  "property_seo_description_sitemap": "Navigate the Heritage at Deer Valley in Phoenix, AZ. Our sitemap makes it easy to find your perfect home amidst our vibrant community offerings!",
  "property_seo_title_thankyou": "Thank You | Apartments in Phoenix, AZ",
  "property_seo_description_thankyou": "Thank you for contacting the leasing team. We will be in touch shortly to assist you in finding your new home in Phoenix.",
  "property_seo_title_pets": "Pets | Pet Friendly Apartments in Phoenix, AZ",
  "property_seo_description_pets": "Heritage at Deer Valley offers the best pet-friendly living in Phoenix. Check out our pet policy today and get a step closer to living with your furry friend.",
  "property_updated_at": "1786643074647",
  "amenities": [
    {
      "id": "custom_9f1dadda-ef29-4f79-978d-f604566a3661",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_efef479d-cc40-413b-8835-377438562983",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Two Sand Volleyball Courts",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e1d03a84-d823-4066-b2f5-f62ba84f028b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Additional Storage Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_599220cf-98c9-49e6-8b14-0f92c38949bf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Relaxing Spa with Seating",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ba4581c9-b07f-4201-95c6-9be0171012d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Three Resort Style Swimming Pools",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_15444bb8-9422-414a-b519-a0a1f280867e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Club",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fdf38ff8-4bd0-453c-8022-88292cef6487",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Cycle/Spin Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ef81b262-53bc-4a95-b15e-cb61c6ada505",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Accessible Access to Major Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_be0d1686-6640-4610-8462-50ab74d513fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7d27ce05-adbe-46ed-aa45-855061bca579",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a4a5c745-9aa7-4ab3-b603-bf0f7fca35da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Resident BBQ Areas Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d409470a-3de7-4fc7-9d2e-2d5a0feb6a87",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6c51d6e4-93ec-4692-aa46-2ba072089d4e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Parcel Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9822148b-9a00-4d38-94ba-6694d4b6e8bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9ebfd232-63a4-4b76-88c6-1ba6daacd510",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Two Tot Lots",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f1775f9e-60be-4339-a06f-1683dc48e6db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_dea6d090-9633-44b9-b99b-a77f93fde297",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Apartments*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ae47189e-5af9-473f-8c48-7395b1137d86",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Style Plank Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e3d431dd-1383-40c9-975d-84a143c79ed8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Peninsulas*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c4b9e385-ae61-48b7-9228-1c454b378d58",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_43089ead-a360-4d0b-b130-f141ebec6fa7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Storage/ Linen Closets*",
      "amount": "false",
      "description": "In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4667e5a9-0f7f-43f9-83e4-fa70097d0b52",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7b424e8d-faa6-4971-8ef4-390e11b0275d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Private Terrace/ Balcony*",
      "amount": "false",
      "description": "In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_753446c1-5a62-40a1-bff4-86cb98950d22",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Full Size Washers and Dryers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7e2a3a58-42cf-4fd0-a2bc-a36a37a60bad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_90c7e3c4-dee5-420c-a609-4573648d75db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "external_id": "false",
      "title": "Built In Computer Niches*",
      "amount": "false",
      "description": "In Select Units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e1c95abe-0547-40e6-a68d-d090c806c876",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-2a86-7628-89bd-2c6cc7f8ee8c.webp",
      "image_media": {
        "alt_text": "Modern leasing office with a dark granite reception desk, stylish pendant lights, and large windows at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-2a86-7628-89bd-2c6cc7f8ee8c",
        "storage_key": "property/6767906449166434/01a010f4-2a86-7628-89bd-2c6cc7f8ee8c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our modern leasing office, featuring a sleek reception desk, designer lighting, and a bright, open atmosphere. Your first impression is everything.",
      "link": "",
      "alt_text": "Modern leasing office with a dark granite reception desk, stylish pendant lights, and large windows at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2818748-74a2-4b9d-863f-e44386ceb2dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-1cf6-7434-8a4b-ac53d0ebfa18.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-1cf6-7434-8a4b-ac53d0ebfa18",
        "storage_key": "property/6767906449166434/01a010f4-1cf6-7434-8a4b-ac53d0ebfa18.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring plush seating and a serene blue wave mural. A perfect space to socialize or enjoy a quiet moment.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2cafede2-6e49-4730-8cf2-f8a2a9063d41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-24c6-76ea-8f80-70fd935af6b0.webp",
      "image_media": {
        "alt_text": "Fully equipped gym with weight machines, free weights, benches, and yoga mat at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-24c6-76ea-8f80-70fd935af6b0",
        "storage_key": "property/6767906449166434/01a010f4-24c6-76ea-8f80-70fd935af6b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide array of weight machines, free weights, and cardio equipment to support your active lifestyle.",
      "link": "",
      "alt_text": "Fully equipped gym with weight machines, free weights, benches, and yoga mat at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1723ae56-472a-4e58-8f27-31efbfe4af65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-2f66-7316-9063-344770645cc4.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weightlifting equipment, and a stability ball at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-2f66-7316-9063-344770645cc4",
        "storage_key": "property/6767906449166434/01a010f4-2f66-7316-9063-344770645cc4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our fully-equipped fitness center features cardio machines, free weights, and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weightlifting equipment, and a stability ball at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d02c9f9-bfb7-41ce-8c1a-1b38321ea59a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f66a2-4257-734b-858a-858f568a6fbc.webp",
      "image_media": {
        "alt_text": "Smart package lockers in a modern community room.",
        "public_id": "019f66a2-4257-734b-858a-858f568a6fbc",
        "storage_key": "property/6767906449166434/019f66a2-4257-734b-858a-858f568a6fbc.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Convenient and secure package lockers available for residents in the community clubhouse.",
      "link": "",
      "alt_text": "Smart package lockers in a modern community room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ce9facb8/dms3rep/multi/5742705921490944/6767906449166434/c6bf1ec13f4d6172dbfcec3553291468.jpg"
    },
    {
      "id": "custom_3e9b8e9d-a408-409f-95ee-dd6904f9c33e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-6d8f-761d-be11-4385aa0ef32d.webp",
      "image_media": {
        "alt_text": "Modern lounge area with high-top table, chairs, and sofa.",
        "public_id": "01a010f4-6d8f-761d-be11-4385aa0ef32d",
        "storage_key": "property/6767906449166434/01a010f4-6d8f-761d-be11-4385aa0ef32d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and a contemporary aesthetic perfect for unwinding.",
      "link": "",
      "alt_text": "Modern lounge area with high-top table, chairs, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc3c48a7-8f56-44be-a45f-16da6d235b6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f66a2-42c1-759b-85d5-2e58e050308a.webp",
      "image_media": {
        "alt_text": "A communal dining area with a long wooden table and black chairs, facing windows that overlook a courtyard at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "019f66a2-42c1-759b-85d5-2e58e050308a",
        "storage_key": "property/6767906449166434/019f66a2-42c1-759b-85d5-2e58e050308a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish communal dining area, perfect for hosting events or enjoying a casual meal together.",
      "link": "",
      "alt_text": "A communal dining area with a long wooden table and black chairs, facing windows that overlook a courtyard at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ce9facb8/dms3rep/multi/5742705921490944/6767906449166434/aa7a9dd9c74ae8ad7fe57f303fc7ace4.jpg"
    },
    {
      "id": "custom_9d562677-6660-4881-b26f-bc2387ef458f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-7e06-7529-ae1f-22dd1270f69b.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped apartment complex gym with treadmills and weight machines.",
        "public_id": "01a010f4-7e06-7529-ae1f-22dd1270f69b",
        "storage_key": "property/6767906449166434/01a010f4-7e06-7529-ae1f-22dd1270f69b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and weight training equipment.",
      "link": "",
      "alt_text": "Interior view of a well-equipped apartment complex gym with treadmills and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d896e7fb-1f34-41f5-9d6e-69ce0dce6443",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-77b8-72dc-a5a1-b36491f22fb2.webp",
      "image_media": {
        "alt_text": "Fitness center gym with yoga mats, weights, and stability balls at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-77b8-72dc-a5a1-b36491f22fb2",
        "storage_key": "property/6767906449166434/01a010f4-77b8-72dc-a5a1-b36491f22fb2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "",
      "alt_text": "Fitness center gym with yoga mats, weights, and stability balls at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_acb9b7a0-f5d0-4fb3-9f10-1f66f75b9c0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-788c-7078-a63c-85bb182cadaa.webp",
      "image_media": {
        "alt_text": "Children's play area with small tables and chairs, bean bag chairs, and shelves.",
        "public_id": "01a010f4-788c-7078-a63c-85bb182cadaa",
        "storage_key": "property/6767906449166434/01a010f4-788c-7078-a63c-85bb182cadaa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A dedicated children's play area featuring child-sized tables and chairs, comfortable bean bag seating, and ample storage shelves. Perfect for keeping little ones entertained.",
      "link": "",
      "alt_text": "Children's play area with small tables and chairs, bean bag chairs, and shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be532f29-3c79-412f-b42f-56255810be37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-2a89-714f-afb2-bb473802ff29.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa with lounge chairs and a cabana in a multifamily community.",
        "public_id": "01a010f4-2a89-714f-afb2-bb473802ff29",
        "storage_key": "property/6767906449166434/01a010f4-2a89-714f-afb2-bb473802ff29.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool and soothing spa. Enjoy the California sun with plenty of lounge seating and a shaded cabana for your convenience.",
      "link": "",
      "alt_text": "Resort-style swimming pool and spa with lounge chairs and a cabana in a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35ef4dad-3def-4a32-97bf-9d936a5eea86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f66a2-4283-7025-bde0-0469c4e7d219.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a stone base and stainless steel grill, adjacent to a table and chairs under blue umbrellas, with apartment buildings in the background at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "019f66a2-4283-7025-bde0-0469c4e7d219",
        "storage_key": "property/6767906449166434/019f66a2-4283-7025-bde0-0469c4e7d219.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's well-equipped grilling station and comfortable seating area, perfect for entertaining guests.",
      "link": "",
      "alt_text": "Outdoor grilling station with a stone base and stainless steel grill, adjacent to a table and chairs under blue umbrellas, with apartment buildings in the background at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ce9facb8/dms3rep/multi/5742705921490944/6767906449166434/4fd9c0c46e90c5d5cec81e1dab079b0b.jpg"
    },
    {
      "id": "custom_a5f621c4-f9d8-42fb-b6bc-553e041bf3ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-41c4-7758-b461-3961dbd3a57a.webp",
      "image_media": {
        "alt_text": "Playground with blue slide and yellow accents under a tan shade structure at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-41c4-7758-b461-3961dbd3a57a",
        "storage_key": "property/6767906449166434/01a010f4-41c4-7758-b461-3961dbd3a57a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a colorful play structure and shade cover for sunny days.",
      "link": "",
      "alt_text": "Playground with blue slide and yellow accents under a tan shade structure at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e162003c-e9a6-4bcb-a5a0-8158812a7aea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-2fbe-73a8-b771-5fab17d83594.webp",
      "image_media": {
        "alt_text": "Dog park area with agility equipment and benches at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-2fbe-73a8-b771-5fab17d83594",
        "storage_key": "property/6767906449166434/01a010f4-2fbe-73a8-b771-5fab17d83594.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring agility equipment and comfortable seating for pet owners.",
      "link": "",
      "alt_text": "Dog park area with agility equipment and benches at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33859cc9-0d2c-4d22-8b61-fe6766758b44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-8314-708e-8229-ef829fcb5f8f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a large island.",
        "public_id": "01a010f4-8314-708e-8229-ef829fcb5f8f",
        "storage_key": "property/6767906449166434/01a010f4-8314-708e-8229-ef829fcb5f8f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring a full suite of stainless steel appliances, ample cabinet space, and a stunning quartz island perfect for meal prep and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43e4d5f1-b129-419c-8d9f-241f97f837cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f66a2-57ff-754f-9b24-882e648d87ba.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island, stainless steel appliances, and marble table at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "019f66a2-57ff-754f-9b24-882e648d87ba",
        "storage_key": "property/6767906449166434/019f66a2-57ff-754f-9b24-882e648d87ba.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "FEATURED",
      "link": "",
      "alt_text": "Modern kitchen and dining area with island, stainless steel appliances, and marble table at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/ce9facb8/dms3rep/multi/5742705921490944/6767906449166434/530c8bee66d5cb30bff59cb959dc283a.jpg"
    },
    {
      "id": "custom_096cd18f-fecd-4438-9536-2539e9319822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-9136-7599-9318-286bad89735a.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, coffee tables, and patio access.",
        "public_id": "01a010f4-9136-7599-9318-286bad89735a",
        "storage_key": "property/6767906449166434/01a010f4-9136-7599-9318-286bad89735a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a comfortable white sofa, stylish coffee tables, and direct access to a private patio, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with white sofa, coffee tables, and patio access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51f2e91b-4463-4076-a86e-9f2d979a76bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-8cae-740b-bd66-cf1e28f8aa35.webp",
      "image_media": {
        "alt_text": "A king-sized bed with white bedding and a tan throw, a ceiling fan, and artwork in a bedroom.",
        "public_id": "01a010f4-8cae-740b-bd66-cf1e28f8aa35",
        "storage_key": "property/6767906449166434/01a010f4-8cae-740b-bd66-cf1e28f8aa35.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a king-sized bed, soft lighting, and tasteful decor. This space offers comfort and style.",
      "link": "",
      "alt_text": "A king-sized bed with white bedding and a tan throw, a ceiling fan, and artwork in a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed2f434c-c9b7-48b8-9a67-722910b0491a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-1911-74f6-82d6-c62145cebfe4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, grey cabinets, and a double sink at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-1911-74f6-82d6-c62145cebfe4",
        "storage_key": "property/6767906449166434/01a010f4-1911-74f6-82d6-c62145cebfe4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet storage, and a convenient double sink. Perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, grey cabinets, and a double sink at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90e629a9-776c-4ac0-8019-5de5714d5b8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-2b06-77b8-a064-66c315158c1e.webp",
      "image_media": {
        "alt_text": "Modern living room with a teal sofa, leather chair, and TV at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-2b06-77b8-a064-66c315158c1e",
        "storage_key": "property/6767906449166434/01a010f4-2b06-77b8-a064-66c315158c1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable teal sofa, a unique leather accent chair, and a wall-mounted TV, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern living room with a teal sofa, leather chair, and TV at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19e7b596-5ff7-426d-921c-d76df0828156",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-80bd-729a-a726-e8708f704aef.webp",
      "image_media": {
        "alt_text": "King-size bed with white linens and blue velvet headboard, flanked by nightstands, in a well-lit bedroom at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-80bd-729a-a726-e8708f704aef",
        "storage_key": "property/6767906449166434/01a010f4-80bd-729a-a726-e8708f704aef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable king-size bed, stylish nightstands, and ample natural light. Perfect for relaxation.",
      "link": "",
      "alt_text": "King-size bed with white linens and blue velvet headboard, flanked by nightstands, in a well-lit bedroom at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_faa13dab-5d6d-49ad-89fc-f8570e7cdf7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/01a010f4-2e07-7645-beec-a7a6db0116fa.webp",
      "image_media": {
        "alt_text": "Balcony view of community grounds with seating and potted plant at Heritage at Deer Valley in Phoenix, AZ.",
        "public_id": "01a010f4-2e07-7645-beec-a7a6db0116fa",
        "storage_key": "property/6767906449166434/01a010f4-2e07-7645-beec-a7a6db0116fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with comfortable seating and lush views of the community grounds. Perfect for relaxing outdoors.",
      "link": "",
      "alt_text": "Balcony view of community grounds with seating and potted plant at Heritage at Deer Valley in Phoenix, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ad779e36-7ebe-4b4b-89d3-b26711e6dedd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Midwestern University",
      "poi_type": "Education",
      "poi_address": "19555 N 59th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-79fe-7118-9f08-470850b81b77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-79fe-7118-9f08-470850b81b77",
        "storage_key": "property/6767906449166434/019d02c9-79fe-7118-9f08-470850b81b77.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://www.midwestern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2223870335671267858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midwestern-university",
      "poi_latitude": "33.6637764",
      "poi_longitude": "-112.1833108",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-572-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d5-707c-9c2f-143dbc8ef3d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d5-707c-9c2f-143dbc8ef3d7",
        "storage_key": "property/6767906449166434/019d02c9-a5d5-707c-9c2f-143dbc8ef3d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Q_nt45oK4cREvI2qEnG3B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5bc9933e-2abf-4e7a-be95-cfcf53d56e89",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Stratosphere Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "5665 W Bell Rd, Glendale, AZ 85308, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, slides, bounce houses, and a ninja course. They highlight the clean facilities, fun atmosphere, and reasonable prices, especially with bundle offers. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-8172-73b8-9c62-588e0b885864.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-8172-73b8-9c62-588e0b885864",
        "storage_key": "property/6767906449166434/019d02c9-8172-73b8-9c62-588e0b885864.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stratosphereadventurepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5909811527245393997&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stratosphere-adventure-park",
      "poi_latitude": "33.6374257",
      "poi_longitude": "-112.1805447",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-767-4737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgWzZLvhpK4cRTXD4wkXeA1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_dc11bcc0-fc5d-4779-8398-bf50da788699",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "24700 N 67th Ave, Peoria, AZ 85383, USA",
      "poi_short_description": "Luxurious athletic club featuring a gym with a large selection of equipment, studio classes and pools.",
      "poi_long_description": "People say this gym has a great selection of amenities, including indoor and outdoor pools, saunas, a jacuzzi, and a cold plunge. They also highlight the friendly and knowledgeable staff, as well as the excellent childcare services and classes.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-88a7-749c-b3a2-2560e19a90c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-88a7-749c-b3a2-2560e19a90c1",
        "storage_key": "property/6767906449166434/019d02c9-88a7-749c-b3a2-2560e19a90c1.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.lifetime.life/locations/az/happy-valley-peoria.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=42146770289567094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.7085318",
      "poi_longitude": "-112.2043113",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 623-259-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f4ZP0BnK4cRdiWKp0O8lQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6c5921b2-c55a-470a-a775-874f5892baf5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2814 W Bell Rd Ste 1490, Phoenix, AZ 85053, USA",
      "poi_short_description": "",
      "poi_long_description": "Gym goers say this gym has a spacious layout with an abundance of fresh, new equipment, and they appreciate the dedicated room for taking photos and videos. They also highlight the friendly and welcoming staff, particularly mentioning Gabe, Jina, and Nitty for their exemplary customer service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-83d9-72f6-b61e-e221fc2b9a73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-83d9-72f6-b61e-e221fc2b9a73",
        "storage_key": "property/6767906449166434/019d02c9-83d9-72f6-b61e-e221fc2b9a73.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.eosfitness.com/gym/phoenix-i-17-w-bell-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=1261832207160007351&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.6415647",
      "poi_longitude": "-112.1195696",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-648-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJea0loVvK4cRt1rr-bTtghE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a4a55341-d90d-4582-8933-71545da65420",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4255 W Thunderbird Rd, Phoenix, AZ 85053, USA",
      "poi_short_description": "Roomy chain facility for gym regulars featuring cardio and weight machines, an indoor pool, free weights and group classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including massage chairs, a pool, a sauna, and a steam room, as well as Studio HIIT classes and personal trainers. They also highlight the friendly and helpful staff, the clean facilities, and the welcoming and well-maintained environment.\n\nSome reviews mention the billing practices can be difficult to deal with.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-88bf-71ba-a3a3-96355cf5c182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-88bf-71ba-a3a3-96355cf5c182",
        "storage_key": "property/6767906449166434/019d02c9-88bf-71ba-a3a3-96355cf5c182.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vasafitness.com/locations/az/phoenix-thunderbird/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1906049609365793961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.6094223",
      "poi_longitude": "-112.150361",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-603-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd65gug1pK4cRqSyFYgWmcxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_06bb5dd6-d690-4b2c-89db-af38be2323d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Mountainside Fitness Happy Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "2501 W Happy Valley Rd Suite 30, Phoenix, AZ 85085, USA",
      "poi_short_description": "Large chain fitness center with a wide range of equipment, classes and staff.",
      "poi_long_description": "People say this fitness center offers a variety of workout options, including classes and individual workouts, and has a well-maintained locker room with amenities like a steam room and sauna. They highlight the clean facilities, new equipment, and friendly staff. They also like the convenient childcare and the welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-8955-72e8-9e98-0089c98fc671.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-8955-72e8-9e98-0089c98fc671",
        "storage_key": "property/6767906449166434/019d02c9-8955-72e8-9e98-0089c98fc671.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/happy-valley/?utm_source=GMB&utm_medium=Local&utm_campaign=HappyValley&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=6868094223304764676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-happy-valley",
      "poi_latitude": "33.7085901",
      "poi_longitude": "-112.1149277",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 602-601-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiz7_bJRlK4cRBC3-r05fUF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_8b0c1f88-73e6-406e-a3a8-510d26b6aae5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Mountainside Fitness Arrowhead",
      "poi_type": "Health and Wellness",
      "poi_address": "20250 N 75th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "Health-club chain offering weight machines, yoga classes, spin courses and other fitness options.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, classes, and amenities, including childcare, a sauna, and massage chairs. They highlight the clean environment, friendly staff, and welcoming atmosphere. They also like the convenient location and the value for the price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-8984-74c9-b621-4a52b57b7b49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-8984-74c9-b621-4a52b57b7b49",
        "storage_key": "property/6767906449166434/019d02c9-8984-74c9-b621-4a52b57b7b49.webp",
        "width": 320,
        "height": 320
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/arrowhead/?utm_source=GMB&utm_medium=Local&utm_campaign=Arrowhead&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9942410235927687337&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-arrowhead",
      "poi_latitude": "33.6689836",
      "poi_longitude": "-112.2226625",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-625-0228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3a_n1wtoK4cRqXCts26J-ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_9ee1fc7e-4d9a-4bb2-9771-c22d8e5bd48b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "320 E Bell Rd, Phoenix, AZ 85022, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines, free weights, and weight machines, and has clean locker rooms with showers. They highlight the quiet, welcoming, and non-judgmental atmosphere, and the helpful and friendly staff. They also like the convenient hours and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-8d10-72d0-a772-8341357ed1ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-8d10-72d0-a772-8341357ed1ba",
        "storage_key": "property/6767906449166434/019d02c9-8d10-72d0-a772-8341357ed1ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/phoenix-north-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5916726555932674058&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.6412615",
      "poi_longitude": "-112.0695092",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-588-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXAU5j5uK4cRCsh8V3RvHFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f261dcb0-5873-469b-81ed-932bc257020e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5536 W Bell Rd, Glendale, AZ 85308, USA",
      "poi_short_description": "Spacious gym featuring treadmills, free weights, squat racks and a huge pool.",
      "poi_long_description": "People say this gym offers a wide variety of machines, free weights, and amenities, including a pool, sauna, and steam room. They also highlight the friendly and helpful staff, and the clean and well-organized facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-8e18-74bd-af45-4d829ab3ac07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-8e18-74bd-af45-4d829ab3ac07",
        "storage_key": "property/6767906449166434/019d02c9-8e18-74bd-af45-4d829ab3ac07.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/pages/clubhome.aspx?clubid=5&Glendale-Arizona+GYM&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12924659868739180882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.6403017",
      "poi_longitude": "-112.1786033",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-547-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-1_I_1oK4cRUhnyPqydXbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_65b87044-342b-45ec-b48e-62f9fbc767f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Banner Thunderbird Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-8ddf-735c-8973-4620cd299882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-8ddf-735c-8973-4620cd299882",
        "storage_key": "property/6767906449166434/019d02c9-8ddf-735c-8973-4620cd299882.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/glendale/banner-thunderbird-medical-center?y_source=1_MTE5MDczNTItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11031221542305799944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-thunderbird-medical-center",
      "poi_latitude": "33.6093624",
      "poi_longitude": "-112.1801493",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-865-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa89-729f-b49e-5a202527844b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa89-729f-b49e-5a202527844b",
        "storage_key": "property/6767906449166434/019d02c9-aa89-729f-b49e-5a202527844b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnx4Z3nFpK4cRCB_G-4vFFpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8f2f1154-2107-489e-97d2-12dd62fca8f1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "HonorHealth Deer Valley Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "19829 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9094-773c-a67b-fe3c23494495.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9094-773c-a67b-fe3c23494495",
        "storage_key": "property/6767906449166434/019d02c9-9094-773c-a67b-fe3c23494495.webp",
        "width": 800,
        "height": 300
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/deer-valley-medical-center?utm_source=GMB&utm_medium=local&utm_campaign=Valley_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15230205930965625593&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honorhealth-deer-valley-medical-center",
      "poi_latitude": "33.6655324",
      "poi_longitude": "-112.1164943",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 623-879-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa89-729f-b49e-5a202527844b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa89-729f-b49e-5a202527844b",
        "storage_key": "property/6767906449166434/019d02c9-aa89-729f-b49e-5a202527844b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fTTNBRvK4cR-epA45mPXNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_af6584c2-10b4-469e-9dd3-521de158a2a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Sonoran Preserve -Desert Vista Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 East Sonoran Desert Drive, Phoenix, AZ 85085, USA",
      "poi_short_description": "Nature preserve with trails for hiking and mountain biking, as well as a public restroom.",
      "poi_long_description": "People say this nature preserve offers well-maintained hiking and biking trails with beautiful scenery. They highlight the trails cater to different levels of hiking and provide opportunities to see various cacti and wildlife. They also like the clean facilities, including flushing toilets and sinks with soap.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-928e-7466-9a93-66a533c42a1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-928e-7466-9a93-66a533c42a1c",
        "storage_key": "property/6767906449166434/019d02c9-928e-7466-9a93-66a533c42a1c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/sonoran-preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=6367885015233353201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sonoran-preserve--desert-vista-trailhead",
      "poi_latitude": "33.74104760000001",
      "poi_longitude": "-112.097442",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa88-778d-ba77-611fc8abff33",
        "storage_key": "property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_X1D2uZkK4cR8VWEz65FX1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d5442355-5954-4806-ae80-87207851f9e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Bellair Golf Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17233 N 45th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "Golf course with an 18-hole short course and driving range, plus an on-site restaurant.",
      "poi_long_description": "People say this golf course offers a fun executive course and driving range with ball tracking technology. They highlight the well-kept greens, affordable prices, and casual, enjoyable round of golf. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-922e-739a-b4eb-d54a4cded18f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-922e-739a-b4eb-d54a4cded18f",
        "storage_key": "property/6767906449166434/019d02c9-922e-739a-b4eb-d54a4cded18f.webp",
        "width": 702,
        "height": 395
      },
      "poi_business_url": "https://www.bellairgolfpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406907117581785615&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellair-golf-park",
      "poi_latitude": "33.6428631",
      "poi_longitude": "-112.1567792",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 602-513-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-ada7-754c-b927-940c70f0b95e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-ada7-754c-b927-940c70f0b95e",
        "storage_key": "property/6767906449166434/019d02c9-ada7-754c-b927-940c70f0b95e.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3deUYXVpK4cRD1oqU3tVq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1798fe53-a158-4551-b1bc-84759742d079",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Cave Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15202 N 19th Ave, Phoenix, AZ 85023, USA",
      "poi_short_description": "Straightforward municipal golf course with challenging greens and mountain views.",
      "poi_long_description": "Golfers say this golf course has nice fairways and greens, and is a great value for the price. They also highlight that it's a fun course to play, with decent course conditions.\n\nSome reviews mention the pace of play can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-939b-7076-b8a1-c0b937084999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-939b-7076-b8a1-c0b937084999",
        "storage_key": "property/6767906449166434/019d02c9-939b-7076-b8a1-c0b937084999.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phoenix.gov/parks/golf/phoenix-golf-courses/cave-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=864888374098375459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cave-creek-golf-course",
      "poi_latitude": "33.6220189",
      "poi_longitude": "-112.1051725",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-534-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-ada7-754c-b927-940c70f0b95e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-ada7-754c-b927-940c70f0b95e",
        "storage_key": "property/6767906449166434/019d02c9-ada7-754c-b927-940c70f0b95e.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0bzF4luK4cRI7N_1GSzAAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_650ab26d-1ee5-454e-b9ef-6c434af271d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Thunderbird Conservation Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22800 N 59th Ave, Glendale, AZ 85310, USA",
      "poi_short_description": "Mountain with easy to moderate trails and a flag at the top, plus scenic views of the valley.",
      "poi_long_description": "Hikers say this park offers a variety of trails with breathtaking views of the valley, especially during sunrise and sunset. They also highlight that it's a great place for families, with well-maintained trails suitable for all levels, and plenty of parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9575-7490-af12-ac92db23ca67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9575-7490-af12-ac92db23ca67",
        "storage_key": "property/6767906449166434/019d02c9-9575-7490-af12-ac92db23ca67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12308427815063559498&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "thunderbird-conservation-park",
      "poi_latitude": "33.6943417",
      "poi_longitude": "-112.1879751",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa88-778d-ba77-611fc8abff33",
        "storage_key": "property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVAGzHNpK4cRSp1mjOJR0Ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_81650d1b-9473-47e6-9d12-5e15c2bc9634",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Lookout Mountain Trailhead #308",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15600 N 16th St, Phoenix, AZ 85022, USA",
      "poi_short_description": "Mountain popular for hiking on trails with panoramic city views and sunsets.",
      "poi_long_description": "People say this hiking area offers trails with breathtaking views. They highlight the convenient parking and the manageable incline of the trails. They also like the quick access to the peak and the beautiful sunset views. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-977e-7223-b1f0-d38eb5122023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-977e-7223-b1f0-d38eb5122023",
        "storage_key": "property/6767906449166434/019d02c9-977e-7223-b1f0-d38eb5122023.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.phoenix.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=16136745154334110358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lookout-mountain-trailhead-308",
      "poi_latitude": "33.6271136",
      "poi_longitude": "-112.0481819",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa88-778d-ba77-611fc8abff33",
        "storage_key": "property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcgLhwJuK4cRljIXwzg88d8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_3ceb152d-df53-40b9-91c2-5d04387fa30c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Phoenix Deer Valley Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "702 W Deer Valley Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this regional airport offers convenient access to North Phoenix. They highlight the friendly and efficient staff. They also like the consistent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9799-755f-955c-291150263ded.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9799-755f-955c-291150263ded",
        "storage_key": "property/6767906449166434/019d02c9-9799-755f-955c-291150263ded.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://deervalleyairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3121833364810829412&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-deer-valley-airport",
      "poi_latitude": "33.6854102",
      "poi_longitude": "-112.083264",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-869-0975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-adfd-7573-bea5-f5699f6b90aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-adfd-7573-bea5-f5699f6b90aa",
        "storage_key": "property/6767906449166434/019d02c9-adfd-7573-bea5-f5699f6b90aa.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3ydkItvK4cRZA6Dtef6Uis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8e8e6ae6-e5f0-4904-9597-80956e1711f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Metro Pkwy",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9a9a-7689-be9c-c2319b8a74f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9a9a-7689-be9c-c2319b8a74f5",
        "storage_key": "property/6767906449166434/019d02c9-9a9a-7689-be9c-c2319b8a74f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095258421458371006&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-pkwy",
      "poi_latitude": "33.575092",
      "poi_longitude": "-112.118469",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7kvo0JsK4cRvgEQiyKR9Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e71712bd-db5d-485b-be7a-ebf150d25023",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "PetSmart Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19601 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9da8-7599-aa48-9c7c99093dcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9da8-7599-aa48-9c7c99093dcb",
        "storage_key": "property/6767906449166434/019d02c9-9da8-7599-aa48-9c7c99093dcb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://pets.petsmart.com/help/contact-us/contact-corporate.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160285302803478114&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "petsmart-corporate-office",
      "poi_latitude": "33.663657",
      "poi_longitude": "-112.1159034",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 888-839-9638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMaK89BZvK4cRYjadaVpM4Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_26063559-58c5-4f28-9079-32a1d846c048",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Honeywell Aerospace Technologies - Deer Valley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21111 N 19th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9cf1-72eb-86a0-5580392bc2e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9cf1-72eb-86a0-5580392bc2e8",
        "storage_key": "property/6767906449166434/019d02c9-9cf1-72eb-86a0-5580392bc2e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=404546493164785334&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honeywell-aerospace-technologies---deer-valley",
      "poi_latitude": "33.6795907",
      "poi_longitude": "-112.09847",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2rtYXZvK4cRto43ZOQ8nQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7b12130f-83bf-4e65-a0f6-b98e70db2af0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Cox Business Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1550 W Deer Valley Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9eda-73ae-9508-911acae368fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9eda-73ae-9508-911acae368fa",
        "storage_key": "property/6767906449166434/019d02c9-9eda-73ae-9508-911acae368fa.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.cox.com/business/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16713051001169255921&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cox-business-corporate-office",
      "poi_latitude": "33.6842677",
      "poi_longitude": "-112.0948226",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-751-9138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWmE_ndvK4cR8R2uBVav8Oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4abf6af1-e7c0-4db9-b346-f66320f5e964",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Maricopa Ambulance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10243 N 19th Ave B, Phoenix, AZ 85021, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-9f51-759c-af5a-cf0f25ea6f88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-9f51-759c-af5a-cf0f25ea6f88",
        "storage_key": "property/6767906449166434/019d02c9-9f51-759c-af5a-cf0f25ea6f88.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.maricopaambulance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12641644849842697492&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maricopa-ambulance",
      "poi_latitude": "33.579714",
      "poi_longitude": "-112.09836",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-485-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd9rip01sK4cRFDWFOwMlcK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_070378df-64b6-4278-9c6d-da8388c3e4cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Best Western Global Operations Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20400 N 29th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a1ac-7652-bfec-25d4365767a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c9-a1ac-7652-bfec-25d4365767a7",
        "storage_key": "property/6767906449166434/019d02c9-a1ac-7652-bfec-25d4365767a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bestwestern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496207644875558879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "best-western-global-operations-center",
      "poi_latitude": "33.6722755",
      "poi_longitude": "-112.1224594",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 602-957-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmRT4B0FvK4cR3w9g6yLhB2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_98efa652-2d3a-41aa-86b1-ab79a0ac6e43",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Caroun Restaurant North Phoenix",
      "poi_type": "Restaurants",
      "poi_address": "18425 N 19th Ave #118, Phoenix, AZ 85023, USA",
      "poi_short_description": "Mediterranean restaurant serving kebabs and other Middle Eastern fare in a casual space with belly dancers.",
      "poi_long_description": "Diners like this restaurant's delicious and authentic Middle Eastern cuisine, especially the flavorful kebabs and shawarma, with generous portions. They also highlight the friendly and attentive staff, along with the warm and inviting atmosphere. Many mention the reasonable prices and the unique experience of robot food delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb388-b225-7702-a482-8848fa473983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb388-b225-7702-a482-8848fa473983",
        "storage_key": "property/6767906449166434/019eb388-b225-7702-a482-8848fa473983.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://caroun-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3882556850106649040&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "caroun-restaurant-north-phoenix",
      "poi_latitude": "33.6532454",
      "poi_longitude": "-112.0983674",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-875-6297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d0-703a-ae48-3286623be474",
        "storage_key": "property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5f1r8t9vK4cR0MndbuKc4TU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_14bdc7ec-24c3-45b7-9372-a2e9b5ed4d9d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "FIRED PIE",
      "poi_type": "Restaurants",
      "poi_address": "3049 Agua Fria Fwy B2, Phoenix, AZ 85027, USA",
      "poi_short_description": "Modern, organic-focused chain offering customizable pizzas & salads, plus local craft beer.",
      "poi_long_description": "People say this pizza restaurant serves delicious pies and offers great customer service with friendly staff. They also highlight the efficient and accurate service, making it a convenient option for takeout and delivery.\n\nSome reviews mention the quality of the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb388-af19-7377-a7e3-c57c0179bc94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb388-af19-7377-a7e3-c57c0179bc94",
        "storage_key": "property/6767906449166434/019eb388-af19-7377-a7e3-c57c0179bc94.webp",
        "width": 1280,
        "height": 1106
      },
      "poi_business_url": "https://firedpie.com/store/deer-valley-towne-center-phoenix/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16657397786090788035&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fired-pie",
      "poi_latitude": "33.6667274",
      "poi_longitude": "-112.124381",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-879-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d0-703a-ae48-3286623be474",
        "storage_key": "property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5qRXY0_K4cRw9RRIgj3Kuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8a9cf730-0f90-445b-8c49-0c9a9cd90a2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Lookout Tavern",
      "poi_type": "Restaurants",
      "poi_address": "830 E Greenway Pkwy #100, Phoenix, AZ 85022, USA",
      "poi_short_description": "Spacious option for pub eats including weekend brunch, sports on numerous TVs & bar games till late.",
      "poi_long_description": "Reviewers consistently praise this sports bar for its delicious food, including flavorful burgers, wings, and good gluten-free options, alongside the many TVs available for game viewing. Guests also enjoy the fun and lively atmosphere, complemented by the friendly and attentive staff.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb388-b473-743f-8ad4-6b5b89dd6e07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb388-b473-743f-8ad4-6b5b89dd6e07",
        "storage_key": "property/6767906449166434/019eb388-b473-743f-8ad4-6b5b89dd6e07.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://lookoutaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176664566593662208&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lookout-tavern",
      "poi_latitude": "33.6381758",
      "poi_longitude": "-112.0625555",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-926-9786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d0-703a-ae48-3286623be474",
        "storage_key": "property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdffrgj1uK4cRAK3a3WrFX-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_53a0a960-3941-4b67-ac90-dd1e75b04cf1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Barrio Brewing Co. - Deer Valley",
      "poi_type": "Restaurants",
      "poi_address": "702 W Deer Valley Rd, Phoenix, AZ 85027, USA",
      "poi_short_description": "Laid-back breakfast joint featuring hamburgers, fish tacos, and sandwiches alongside brews.",
      "poi_long_description": "Reviewers consistently praise this brewery for its wide selection of craft beers, fun atmosphere, and great views of planes taking off and landing.\n\nOther reviews mention the service can be slow and the food can be poorly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb388-afc0-73df-82d1-ea21270f59e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb388-afc0-73df-82d1-ea21270f59e9",
        "storage_key": "property/6767906449166434/019eb388-afc0-73df-82d1-ea21270f59e9.webp",
        "width": 1280,
        "height": 677
      },
      "poi_business_url": "http://www.barriobrewingphoenix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2077023645773199247&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barrio-brewing-co---deer-valley",
      "poi_latitude": "33.685582",
      "poi_longitude": "-112.0826654",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-858-0232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d0-703a-ae48-3286623be474",
        "storage_key": "property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6pqc5BvK4cRj_dlVAAS0xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2400ab97-e018-49e8-a030-fd40e8d2b4d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Romano's Macaroni Grill",
      "poi_type": "Restaurants",
      "poi_address": "2949 Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Lively Italian chain with an open kitchen, known for small plates, pizzas, pastas & wine.",
      "poi_long_description": "Lively Italian chain with an open kitchen, known for small plates, pizzas, pastas & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb388-af35-763c-9ae2-30af7001fc85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb388-af35-763c-9ae2-30af7001fc85",
        "storage_key": "property/6767906449166434/019eb388-af35-763c-9ae2-30af7001fc85.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.macaronigrill.com/locations/location?id=1704",
      "poi_directions_map_url": "https://maps.google.com/?cid=4385861145294224744&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "romanos-macaroni-grill",
      "poi_latitude": "33.667619",
      "poi_longitude": "-112.122305",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-580-8681",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d0-703a-ae48-3286623be474",
        "storage_key": "property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYxIdT9vK4cRaD1zb3m13Tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6069319a-ad0a-4a68-9c0e-bcfbf45bcae8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "10047 N Metro Pkwy E, Phoenix, AZ 85051, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Diners say this steak house serves up delicious steaks, burgers, and brussel sprouts. They also highlight the friendly and attentive service, and the good value for the price.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb388-b269-758e-ac20-bb48d172909d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb388-b269-758e-ac20-bb48d172909d",
        "storage_key": "property/6767906449166434/019eb388-b269-758e-ac20-bb48d172909d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/az/phoenix/phoenix-metro-center/5513?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:phoenix-az-5513_pl:locurl_rd:1447",
      "poi_directions_map_url": "https://maps.google.com/?cid=10972270139161532888&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.57808",
      "poi_longitude": "-112.11808",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-216-9531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d0-703a-ae48-3286623be474",
        "storage_key": "property/6767906449166434/019d02c9-a5d0-703a-ae48-3286623be474.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpX5ZE0JsK4cR2FlZ2I5VRZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_43b533f8-e8e1-40ed-b178-5b2e269353a9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Deer Valley Towne Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2805 Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Longtime strip mall with brand-name retailers, diverse restaurants, beauty salons & a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, restaurants, and entertainment options, including a movie theater and activities. They also highlight the convenient location, ample parking, and friendly service.\n\nOther reviews mention the cement can be in disrepair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38a-aac0-7015-aea8-12ae27c42b64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-aac0-7015-aea8-12ae27c42b64",
        "storage_key": "property/6767906449166434/019eb38a-aac0-7015-aea8-12ae27c42b64.webp",
        "width": 1280,
        "height": 575
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9676702568367338561&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "deer-valley-towne-center",
      "poi_latitude": "33.6675286",
      "poi_longitude": "-112.1207011",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5da-74bd-997e-124184d1666a",
        "storage_key": "property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJRoIrz9vK4cRQTSlcLeNSoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_cefbba1c-9e11-4d40-b648-7c42574fb198",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Pinnacle Peak Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2805 Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Family-friendly market selling fresh produce and handmade baked goods and other wares.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38a-a940-76cc-a05f-7432cff63971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-a940-76cc-a05f-7432cff63971",
        "storage_key": "property/6767906449166434/019eb38a-a940-76cc-a05f-7432cff63971.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/pinnaclepeakfarmersmarket/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16097365266425642341&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pinnacle-peak-farmers-market",
      "poi_latitude": "33.6676603",
      "poi_longitude": "-112.1201934",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-465-1343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5da-74bd-997e-124184d1666a",
        "storage_key": "property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0QnEHA9mK4cRZf0CHWxUZd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_4e4aef92-7601-4fd6-9ed1-933419da1efa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2727 Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this store for being clean, well-stocked, and offering a great selection of items at reasonable prices. Reviewers also frequently mention the friendly staff.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38a-a86b-73fc-9e86-76ed1d50f0f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-a86b-73fc-9e86-76ed1d50f0f5",
        "storage_key": "property/6767906449166434/019eb38a-a86b-73fc-9e86-76ed1d50f0f5.webp",
        "width": 1280,
        "height": 886
      },
      "poi_business_url": "https://www.target.com/sl/phoenix-i17-and-sr101/1141",
      "poi_directions_map_url": "https://maps.google.com/?cid=1223936444057445834&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.6661976",
      "poi_longitude": "-112.119013",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-869-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5da-74bd-997e-124184d1666a",
        "storage_key": "property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHZi2hhVvK4cRyuWyD7ZL_BA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_791fc76a-a1ac-4e55-bf21-51ec939cbe7b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "2829 W Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38a-a809-74bf-981e-8ad03e648324.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-a809-74bf-981e-8ad03e648324",
        "storage_key": "property/6767906449166434/019eb38a-a809-74bf-981e-8ad03e648324.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/AZ/Phoenix/9922/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3028701074388584903&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "33.6663165",
      "poi_longitude": "-112.1205512",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-587-8335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5da-74bd-997e-124184d1666a",
        "storage_key": "property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzeBCqkBvK4cRx4nGlZQbCCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_7e29a8a0-5997-47d8-b441-31b918f89551",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Sportsman's Warehouse",
      "poi_type": "Shopping & Retail",
      "poi_address": "19205 N 27th Ave, Phoenix, AZ 85027, USA",
      "poi_short_description": "Outdoor recreation chain featuring apparel, footwear, equipment & accessories for adults & kids.",
      "poi_long_description": "People say this outdoor sports store offers a wide selection of merchandise and has many weekly sales. They also highlight the friendly, accommodating, and knowledgeable staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38a-a81c-74cb-b805-2a5b5ccae03b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38a-a81c-74cb-b805-2a5b5ccae03b",
        "storage_key": "property/6767906449166434/019eb38a-a81c-74cb-b805-2a5b5ccae03b.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "https://stores.sportsmans.com/sportsmans-warehouse/us/az/phoenix/19205-n-27th-avenue?utm_source=google&utm_medium=organic&utm_campaign=GMB&y_source=1_OTg4MDE2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5114332468787115309&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sportsmans-warehouse",
      "poi_latitude": "33.661284",
      "poi_longitude": "-112.1154842",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-516-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5da-74bd-997e-124184d1666a",
        "storage_key": "property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYVA7CRdvK4cRLXVNkUjC-UY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_43c2675b-3824-4f00-bf77-68aec9a3cea3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "AMC Deer Valley 17",
      "poi_type": "Entertainment",
      "poi_address": "3033 W Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Movie chain with reclining seats and stadium-style seating for both mainstream and 3-D films.",
      "poi_long_description": "Reviewers praise this movie theater for its comfortable reclining seats, a wide variety of movies shown across many screens, friendly staff, and convenient online booking. These features contribute to a highly positive movie-going experience.\n\nSome reviews mention the theaters can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38c-7839-77c5-8dfb-9423e5508a6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38c-7839-77c5-8dfb-9423e5508a6e",
        "storage_key": "property/6767906449166434/019eb38c-7839-77c5-8dfb-9423e5508a6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/phoenix/amc-deer-valley-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1189483683756162139&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-deer-valley-17",
      "poi_latitude": "33.666029",
      "poi_longitude": "-112.1240247",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-434-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38c-7f1c-776d-b8fe-f60544ab9d65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019eb38c-7f1c-776d-b8fe-f60544ab9d65",
        "storage_key": "property/6767906449166434/019eb38c-7f1c-776d-b8fe-f60544ab9d65.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJaTPAPD9vK4cRW7xotBvlgRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9ef35f67-66a4-4998-9d03-2a3dd7c7652e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Breakthrough Smash Room",
      "poi_type": "Entertainment",
      "poi_address": "3414 W Union Hills Dr Ste #8, Phoenix, AZ 85027, USA",
      "poi_short_description": "Stress-relieving amusement center where visitors smash bottles, printers and other items with sledgehammers in a safe environment.",
      "poi_long_description": "People say this smash room offers a fun and therapeutic way to release stress and anger, providing a variety of items to demolish, including optional add-ons like printers and keyboards. Visitors highlight the excellent value, with reasonable pricing and the option to bring their own smashables. Guests mention the staff are friendly, helpful, and ensure a safe experience, even accommodating special requests like birthday messages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38c-7797-740a-a483-01258180985c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38c-7797-740a-a483-01258180985c",
        "storage_key": "property/6767906449166434/019eb38c-7797-740a-a483-01258180985c.webp",
        "width": 543,
        "height": 312
      },
      "poi_business_url": "https://breakthroughsmashroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14736936878930781295&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "breakthrough-smash-room",
      "poi_latitude": "33.6552934",
      "poi_longitude": "-112.1327999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-753-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkfg91NJvK4cRb-QFAgMehMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_69431f62-a0f8-4e91-b7fb-0f4ef11f7e9a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Phoenix Hot Air Balloon Rides- Aerogelic Ballooning",
      "poi_type": "Entertainment",
      "poi_address": "2136 W Melinda Ln, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38c-782c-7396-a106-432bd007a31c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38c-782c-7396-a106-432bd007a31c",
        "storage_key": "property/6767906449166434/019eb38c-782c-7396-a106-432bd007a31c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.aerogelicballooning.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17359124782809207082&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phoenix-hot-air-balloon-rides--aerogelic-ballooning",
      "poi_latitude": "33.6822152",
      "poi_longitude": "-112.1058473",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-402-8041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa85-7458-beba-e3b6ebcb9073",
        "storage_key": "property/6767906449166434/019d02c9-aa85-7458-beba-e3b6ebcb9073.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_Pnk7SnK4cRKtEFcwQA6PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tour_agency"
    },
    {
      "id": "custom_b7621c88-87e6-480d-9499-856b678e44ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Telephone Pioneer Park",
      "poi_type": "Entertainment",
      "poi_address": "JVXX+P2P, 1946 W Morningside Dr, Phoenix, AZ 85023, USA",
      "poi_short_description": "Kid-friendly space with a playground and pool, plus a basketball court and baseball field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019eb38c-7945-7058-a679-4bba76792c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb38c-7945-7058-a679-4bba76792c65",
        "storage_key": "property/6767906449166434/019eb38c-7945-7058-a679-4bba76792c65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/parks/alphabetical/t-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11139805144101407519&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "telephone-pioneer-park",
      "poi_latitude": "33.6491194",
      "poi_longitude": "-112.1016333",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-262-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa88-778d-ba77-611fc8abff33",
        "storage_key": "property/6767906449166434/019d02c9-aa88-778d-ba77-611fc8abff33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh1bF0_1uK4cRH8s74cGJmJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_75549985-722a-4ddb-8023-7fbac3f5edd0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Park Meadows Elementary School",
      "poi_type": "Education",
      "poi_address": "20012 N 35th Ave, Glendale, AZ 85308",
      "poi_short_description": "Zoned Deer Valley USD elementary school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "50",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d1bf9237-2657-4943-b2f0-a5bfcee00973",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Deer Valley Middle School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "Zoned Deer Valley USD middle school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "26",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e25b56a-41d3-45a4-8dc9-df8e68396217",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Barry Goldwater High School",
      "poi_type": "Education",
      "poi_address": "2820 W Rose Garden Ln, Phoenix, AZ 85027",
      "poi_short_description": "Zoned Deer Valley USD high school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_91d956c9-fda0-43ab-a90e-85f263e58139",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Deem Hills Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5050 W Andrea Ln, Phoenix, AZ 85083",
      "poi_short_description": "About 1,000-acre Sonoran desert preserve with hiking and biking trails.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "80",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe7b3ca2-efb3-4112-aabe-15c34d155984",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Valley Metro Route 27 - 27th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "27th Ave & Deer Valley Rd, Phoenix, AZ 85027",
      "poi_short_description": "Closest bus line; runs the 27th Ave corridor north-south.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4592bbd5-61dc-47f9-8fb2-7164968e8e8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Bell / I-17 (Deer Valley) Park-and-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "16808 N Black Canyon Hwy, Phoenix, AZ 85053",
      "poi_short_description": "Largest nearby transit hub; served by the I-17 RAPID and Routes 27 and 170.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "36",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d620f7e3-d4a8-4e8f-8c97-746f5ed19298",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "USAA Phoenix (Norterra campus)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "25700 N Norterra Pkwy, Phoenix, AZ 85085",
      "poi_short_description": "Large north-Phoenix regional campus and major employer.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "100",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8db86069-6651-442e-82d9-3a3c38451cdf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Sunrise Preschools",
      "poi_type": "Education",
      "poi_address": "3401 W Union Hills Dr, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f0587-cb51-769c-b0b7-30eeb7aba775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0587-cb51-769c-b0b7-30eeb7aba775",
        "storage_key": "property/6767906449166434/019f0587-cb51-769c-b0b7-30eeb7aba775.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://schools.sunrisepreschools.com/az/phoenix/3401-w-union-hills-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=10490563428579803086&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunrise-preschools",
      "poi_latitude": "33.6536334",
      "poi_longitude": "-112.1317217",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 602-978-9545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d5-707c-9c2f-143dbc8ef3d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d5-707c-9c2f-143dbc8ef3d7",
        "storage_key": "property/6767906449166434/019d02c9-a5d5-707c-9c2f-143dbc8ef3d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfY_lkC9vK4cRzv8zXtv3lZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_d8b32ec9-a259-47f2-a253-e2df87a0043c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "We Love Kids",
      "poi_type": "Education",
      "poi_address": "18631 N 19th Ave #120, Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f0587-ca73-7578-82f3-d862d8f2c4a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0587-ca73-7578-82f3-d862d8f2c4a4",
        "storage_key": "property/6767906449166434/019f0587-ca73-7578-82f3-d862d8f2c4a4.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17862944535984429682&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "we-love-kids",
      "poi_latitude": "33.6566182",
      "poi_longitude": "-112.0983765",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-780-9222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5d5-707c-9c2f-143dbc8ef3d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5d5-707c-9c2f-143dbc8ef3d7",
        "storage_key": "property/6767906449166434/019d02c9-a5d5-707c-9c2f-143dbc8ef3d7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrRwyHgFvK4cRclrb3Wnt5fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_de55de9e-e57b-454c-beff-c4f1732f169a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Deer Valley Petroglyph Preserve",
      "poi_type": "Entertainment",
      "poi_address": "3711 W Deer Vly Rd, Glendale, AZ 85308, USA",
      "poi_short_description": "Petroglyphs are the focus of this outdoor area and indoor museum, which opened in 1994.",
      "poi_long_description": "Visitors say this tourist destination offers a large number of ancient petroglyphs and an interesting museum with educational information. They also highlight the easy, short trails and the friendly, informative staff. Others mention it's a great place for a quick, relaxing, and educational visit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f0589-bfac-74dd-a4e1-47d4c7998ac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0589-bfac-74dd-a4e1-47d4c7998ac2",
        "storage_key": "property/6767906449166434/019f0589-bfac-74dd-a4e1-47d4c7998ac2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://deervalley.asu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8152521538304601045&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "deer-valley-petroglyph-preserve",
      "poi_latitude": "33.6772584",
      "poi_longitude": "-112.1526677",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-582-8007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-aa83-73e8-a24d-05887e6cf81c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-aa83-73e8-a24d-05887e6cf81c",
        "storage_key": "property/6767906449166434/019d02c9-aa83-73e8-a24d-05887e6cf81c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI40YV1RvK4cR1etdKiWTI3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_57dbba34-5df8-48ac-b24d-753694c00fbd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "27th Av & Deer Valley Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Phoenix, AZ 85027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5843594150009699615&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "27th-av--deer-valley-rd",
      "poi_latitude": "33.6833427",
      "poi_longitude": "-112.1175162",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f05bd-a4ed-74bf-b2c7-59fd99ed5690.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f05bd-a4ed-74bf-b2c7-59fd99ed5690",
        "storage_key": "property/6767906449166434/019f05bd-a4ed-74bf-b2c7-59fd99ed5690.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9vdCmdvK4cRH_3gMuudGFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_431baebd-7829-41da-aca1-e74cea708407",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "2929 W Agua Fria Fwy, Phoenix, AZ 85027, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019f05bd-9f9c-75b7-bd0b-fd7333252b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f05bd-9f9c-75b7-bd0b-fd7333252b35",
        "storage_key": "property/6767906449166434/019f05bd-9f9c-75b7-bd0b-fd7333252b35.webp",
        "width": 1280,
        "height": 732
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11199279446767216115&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "33.6662398",
      "poi_longitude": "-112.1220191",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 623-780-3277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a5da-74bd-997e-124184d1666a",
        "storage_key": "property/6767906449166434/019d02c9-a5da-74bd-997e-124184d1666a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDanSCj9vK4cR86XkDFLVa5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    }
  ],
  "office_hours": [
    {
      "id": "ec_41eb9947961e9c752206e5a3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_292383c8dfa745080fcdab67",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_424dceae808d7cb7c08f6559",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3cb13c6ad0557e26794c4378",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a9b410e533236341da8964a1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b3bb40a9a54187fbc17ca20f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d6279870-9a2c-464c-b658-bb1559dfb004",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "rating": "4.0",
      "name": "Uday Ramesh",
      "text": "I’ve really enjoyed staying at Heritage at Deer Valley in Phoenix, AZ. The community is peaceful, with well-maintained green spaces and a relaxing atmosphere. The landscaping is beautiful—especially the unique curved tree in the courtyard. The pool area is clean, quiet, and a great place to unwind, complete with comfortable lounge chairs and shaded seating. The entire complex feels safe, with gated access and friendly neighbors. The location is convenient, with nearby stores and freeway access. Overall, it’s a great balance of comfort, aesthetics, and value. Highly recommend for anyone looking for a clean and calm apartment community.",
      "date": "2025-05-07",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_49115043-5f9b-4a70-a262-1bf25b8b4e53",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02ca-e834-728c-90e0-f13d5359f891.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern reception area with wood accents and decorative lighting.",
        "public_id": "019d02ca-e834-728c-90e0-f13d5359f891",
        "storage_key": "property/6767906449166434/019d02ca-e834-728c-90e0-f13d5359f891.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Leasing Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6sWMcaoryrf"
    },
    {
      "id": "custom_28ce0375-0268-40b7-88b7-b43fb1826e4b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02ca-e8d9-70e7-ae67-97669b7936cf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with cardio machines and weight training equipment.",
        "public_id": "019d02ca-e8d9-70e7-ae67-97669b7936cf",
        "storage_key": "property/6767906449166434/019d02ca-e8d9-70e7-ae67-97669b7936cf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UEaX6SPj3Xf"
    },
    {
      "id": "custom_f2580ac4-3d93-4fdd-b91b-0c43d9323e33",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02ca-e82e-769a-8a55-a36a7fd02d0e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open concept living area with kitchen island, dining area, and living room.",
        "public_id": "019d02ca-e82e-769a-8a55-a36a7fd02d0e",
        "storage_key": "property/6767906449166434/019d02ca-e82e-769a-8a55-a36a7fd02d0e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1058 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nYYvRAfWFsw"
    },
    {
      "id": "custom_2e28a172-1c7b-43bd-996b-8dd96f1ea682",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166434/019d02ca-e82d-71f9-acc2-e0038d1531d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a blue sofa, glass coffee table, and brown leather chair.",
        "public_id": "019d02ca-e82d-71f9-acc2-e0038d1531d7",
        "storage_key": "property/6767906449166434/019d02ca-e82d-71f9-acc2-e0038d1531d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 1 BR, 1 BA | 658 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Sqg4jJxxQNR"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfc7-d687-70a1-800c-3444b7219e5a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-heritage-at-deer-valley-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434"
    },
    {
      "lead_collector_id": "019ecc24-6190-7774-9534-13841292a2df",
      "lead_source": "LANDING_PAGE",
      "name": "amc-heritage-at-deer-valley-lp",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-deer-valley",
      "search_query": "apartments with in-unit laundry in Deer Valley",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover Heritage at Deer Valley, where convenience meets comfort. Our apartments are perfect for those seeking in-unit laundry facilities.",
      "page_copy": "Welcome to Heritage at Deer Valley, where modern convenience complements comfortable living. Nestled in the heart of the Deer Valley neighborhood, our apartments offer in-unit laundry amenities that make everyday living a breeze. Imagine the ease of having your own laundry facilities right at home, ensuring you have more time to enjoy our community's relaxing spa, spacious walk-in closets, and resident BBQ areas.\n\nOur amenity-rich environment is designed with residents in mind, featuring two tot lots for little ones to explore and additional storage options that provide ample space for all your essentials. Located in vibrant Maricopa County, Heritage at Deer Valley not only meets the demand for convenience with in-unit laundry but also invites you to unwind in style. Discover the perfect blend of practicality and luxury in your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry - Heritage at Deer Valley",
      "seo_description": "Discover Heritage at Deer Valley with in-unit laundry. Enjoy our spa, walk-in closets, and BBQ areas in the vibrant Deer Valley neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-phoenix-az",
      "search_query": "dog-friendly apartments in Phoenix AZ",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Phoenix AZ",
      "h2_subtitle": "Heritage at Deer Valley welcomes you and your pets. Our dog-friendly apartment community in Phoenix, AZ is perfect for animal lovers.",
      "page_copy": "Located in the sunny city of Phoenix, AZ, Heritage at Deer Valley offers dog-friendly apartments designed for you and your furry friend's comfort. Enjoy the wonderful walking trails and pet-friendly atmosphere that make life delightful for both you and your pet. Plus, with spacious floor plans and plush features like walk-in closets, you'll love calling our community home.\n\nWe know pets are family, which is why Heritage at Deer Valley is committed to providing a welcoming environment for all residents, two-legged and four-legged alike. Relax at our resident BBQ areas or in our serene spa while your pet enjoys the great outdoors. With additional storage options, it's easy to keep all of your pet's supplies organized and accessible. Come see why our community is the ideal choice for dog lovers in Phoenix!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments - Heritage at Phoenix AZ",
      "seo_description": "Find dog-friendly apartments at Heritage in Phoenix, AZ. Enjoy walk-in closets, BBQ areas, and a welcoming environment for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-with-resort-style-pools-phoenix",
      "search_query": "apartments with resort-style pools in Phoenix",
      "category": "Amenity",
      "h1_title": "Apartments with Resort-Style Pools",
      "h2_subtitle": "Welcome to Heritage at Deer Valley, where resort-style living awaits. Our Phoenix community features luxurious pool amenities.",
      "page_copy": "Experience the best of resort-style living at Heritage at Deer Valley. Located in Phoenix, our apartments provide the perfect blend of comfort and style, highlighted by our luxurious pool areas. Designed for relaxation and socializing, our community spa with seating offers a serene escape from the hustle and bustle of daily life.\n\nBeyond our stunning pool amenities, residents enjoy spacious living accommodations with walk-in closets and additional storage options, ensuring convenience at every turn. Nestled in beautiful Deer Valley, our community also boasts resident BBQ areas and tot lots, creating a vibrant environment for individuals and families alike. Discover the unparalleled amenities that make Heritage at Deer Valley a premier destination for apartment living in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments - Heritage Phoenix",
      "seo_description": "Discover Heritage at Deer Valley in Phoenix, featuring resort-style pools, walk-in closets, and community BBQ areas for an unparalleled living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "fitness-club-apartments-maricopa-county",
      "search_query": "fitness club apartments in Maricopa County",
      "category": "Amenity",
      "h1_title": "Fitness Club Apartments in Maricopa County",
      "h2_subtitle": "Heritage at Deer Valley in Maricopa County offers fitness-oriented living. Enjoy convenient access to fitness amenities steps from your home.",
      "page_copy": "Welcome to Heritage at Deer Valley, strategically located in the vibrant Maricopa County and designed with an active lifestyle in mind. While we do not currently offer a traditional fitness club on-site, our amenities and location make it easy to maintain a healthy lifestyle. Enjoy walking or jogging around our inviting community and take advantage of nearby fitness facilities in Deer Valley.\n\nResidents at Heritage at Deer Valley benefit from spacious interiors that feature walk-in closets and additional storage, ideal for organizing all of your fitness gear. After a good workout or a busy day, relax in our calming spa with comfortable seating areas, or enjoy a meal in our resident BBQ spaces. This community offers a unique blend of leisure and practical amenities that enhance every aspect of your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Club Inspired Apartments - Heritage Maricopa",
      "seo_description": "Explore fitness-friendly living at Heritage Deer Valley, Maricopa County. Enjoy spacious apartments and relaxing spa amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-with-private-balconies-85027",
      "search_query": "apartments with private balconies 85027",
      "category": "Amenity",
      "h1_title": "Apartments with Private Balconies 85027",
      "h2_subtitle": "Discover Heritage at Deer Valley in the 85027 area. Enjoy the comfort and privacy of your own balcony in our spacious Phoenix apartments.",
      "page_copy": "Imagine sipping your morning coffee on a private balcony, enjoying stunning views of Phoenix. At Heritage at Deer Valley, located in the 85027 ZIP code, you can bring this vision to life. Our apartments are designed with spaciousness and comfort in mind, offering the perfect setting for relaxation and enjoyment right at home.\n\nIn addition to the charm of private balconies, our community offers various other amenities including two tot lots, a tranquil spa with seating, and resident BBQ areas. With the added convenience of walk-in closets and optional storage, Heritage at Deer Valley caters to all your lifestyle needs. Experience apartment living where serene relaxation meets modern conveniences in one of Phoenix's most desirable locations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Balcony Apartments - Heritage 85027",
      "seo_description": "Enjoy private balconies at Heritage Deer Valley in the 85027 area. Spacious apartments with walk-in closets and relaxation amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-phoenix-az",
      "search_query": "one bedroom apartments in Phoenix AZ",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Phoenix, AZ",
      "h2_subtitle": "Explore one bedroom living at Heritage at Deer Valley in Phoenix, AZ. Our community offers spacious layouts and convenient amenities.",
      "page_copy": "Find your perfect one bedroom apartment at Heritage at Deer Valley in the heart of Phoenix, AZ. Our thoughtfully designed apartments feature spacious layouts, ensuring you have ample room to make your home truly yours. Located in a lively neighborhood, our community is the ideal setting for both relaxation and adventure.\n\nResidents enjoy a variety of top-notch amenities including two tot lots and a relaxing spa with comfortable seating areas. Heritage at Deer Valley takes convenience to the next level with walk-in closets and the option for additional storage, perfect for accommodating your belongings. Embrace comfortable living fitted within a vibrant community atmosphere at Phoenix’s esteemed Heritage at Deer Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments - Heritage Phoenix, AZ",
      "seo_description": "Discover spacious one bedroom apartments in Phoenix, AZ, at Heritage Deer Valley. Enjoy walk-in closets and a relaxing environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-maricopa-county",
      "search_query": "two bedroom apartments near Maricopa County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Maricopa County",
      "h2_subtitle": "Discover two-bedroom living at Heritage at Deer Valley, perfectly situated near Maricopa County. Experience spacious comfort and modern convenience.",
      "page_copy": "If you're searching for two bedroom apartments near Maricopa County, Heritage at Deer Valley is the ideal choice. Located in a prime spot close to the vibrant heartbeat of Phoenix, our two bedroom apartments provide ample space and comfort, suited for families, roommates, or anyone needing a bit more room.\n\nIn our community, you'll enjoy a variety of amenities like two tot lots, a calming spa with seating, and BBQ areas perfect for relaxed gatherings. Each apartment comes with spacious walk-in closets and options for additional storage, ensuring all your belongings fit perfectly. Choose Heritage at Deer Valley for a seamless blend of space, convenience, and a welcoming community atmosphere.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - Heritage Near Maricopa",
      "seo_description": "Comfortable two bedroom apartments near Maricopa at Heritage Deer Valley. Enjoy spacious living with modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-deer-valley",
      "search_query": "three bedroom apartments in Deer Valley",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Deer Valley",
      "h2_subtitle": "Find spacious three bedroom living at Heritage at Deer Valley. Enjoy comfort and convenience in a remarkable community.",
      "page_copy": "Heritage at Deer Valley offers unparalleled three bedroom apartments nestled in the scenic Deer Valley area. Our apartments are designed to provide space, comfort, and modern living essentials for families or individuals seeking extra room. Located in Phoenix, our community is the perfect blend of tranquility and accessibility, making it a sought-after address.\n\nEnjoy a host of community amenities including two tot lots and a soothing spa with seating areas—ideal for relaxation after a busy day. Whether you’re hosting a BBQ using our resident facilities or appreciating the extra storage and spacious walk-in closets, Heritage at Deer Valley delivers an exceptional lifestyle. Choose our three bedroom apartments to experience the ideal blend of style, comfort, and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments - Heritage Deer Valley",
      "seo_description": "Discover spacious three bedroom apartments in Deer Valley at Heritage. Offering modern amenities and a welcoming community in Phoenix, AZ.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-midwestern-university-phoenix",
      "search_query": "apartments near midwestern university phoenix",
      "category": "School",
      "h1_title": "Apartments Near Midwestern University Phoenix",
      "h2_subtitle": "Discover convenient living at Heritage at Deer Valley, located near Midwestern University in Phoenix, AZ. Perfect for students and faculty alike.",
      "page_copy": "Heritage at Deer Valley is the ideal choice for those seeking apartments near Midwestern University in Phoenix. Our community is strategically located to offer quick access to the university, making it a perfect home for faculty, students, and staff looking for both convenience and comfort.\n\nOur apartments include a selection of layouts with modern amenities like two tot lots and a relaxing spa, ensuring you can unwind after classes or work. Spacious walk-in closets and additional storage options cater to all your lifestyle needs. Plus, our resident BBQ areas provide a great venue for socializing with fellow residents, creating a warm and friendly community vibe. Choose Heritage at Deer Valley for easy access to Midwestern University and a quality living experience in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Midwestern University - Heritage AZ",
      "seo_description": "Find the ideal apartments near Midwestern University at Heritage Deer Valley. Perfect location and amenities for students and faculty in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-aswvc-phoenix",
      "search_query": "apartments close to arizona state university west valley campus",
      "category": "School",
      "h1_title": "Apartments Close to ASU West Valley Campus",
      "h2_subtitle": "Explore convenient living options at Heritage at Deer Valley, situated close to the Arizona State University West Valley Campus.",
      "page_copy": "Heritage at Deer Valley offers prime apartment living close to the Arizona State University West Valley Campus. Situated to maximize convenience, our community is an ideal choice for students, faculty, and staff who are seeking a comfortable living space with fast access to campus facilities.\n\nEnjoy our array of amenities, including two tot lots, a peaceful spa with seating, and resident BBQ areas that create a welcoming environment. Our apartments are designed with spacious walk-in closets and additional storage options to accommodate all your personal items. Experience a balanced lifestyle at Heritage at Deer Valley, where academic pursuits meet comfortable, modern living in the heart of Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near ASU West Valley - Heritage Phoenix",
      "seo_description": "Convenient apartments near ASU West Valley Campus at Heritage Deer Valley. Ideal for students and faculty, offering modern amenities in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-arizona-christian-university-maricopa",
      "search_query": "apartments near arizona christian university maricopa county",
      "category": "School",
      "h1_title": "Apartments Near Arizona Christian University",
      "h2_subtitle": "Discover convenient apartments at Heritage at Deer Valley, situated near Arizona Christian University in Maricopa County.",
      "page_copy": "Heritage at Deer Valley offers attractive apartment options near Arizona Christian University in Maricopa County. Our ideal location is perfect for students, faculty, and staff looking to minimize commute time and enjoy a supportive community close to academic activities.\n\nExperience the suite of amenities that our community offers, including two inviting tot lots and a spa designed for relaxation after a day of study or work. Spacious walk-in closets and optional additional storage cater to your accommodation needs, while our resident BBQ areas provide a great venue for social gatherings. Choose Heritage at Deer Valley for a blend of convenience and comfort, strategically located in Phoenix.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arizona Christian University - Heritage",
      "seo_description": "Find convenient apartments near Arizona Christian University at Heritage Deer Valley. Perfect student and faculty housing in Maricopa County, Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-banner-thunderbird-medical-center",
      "search_query": "apartments near Banner Thunderbird Medical Center Phoenix",
      "category": "Hospital",
      "h1_title": "Apartments Near Banner Thunderbird Medical Center",
      "h2_subtitle": "Discover Heritage at Deer Valley, conveniently located near Banner Thunderbird Medical Center in Phoenix, AZ. Perfect for healthcare professionals.",
      "page_copy": "If you're seeking apartments near Banner Thunderbird Medical Center in Phoenix, Heritage at Deer Valley is your ideal community. Perfectly positioned for healthcare professionals, our apartments offer a blend of convenience and comfort, making your commute to work quick and stress-free.\n\nEnjoy the modern amenities we offer, including two tot lots for young families and a relaxing spa where you can unwind after a long shift. With spacious walk-in closets, additional storage options, and inviting resident BBQ areas, our community ensures a lifestyle of ease and camaraderie. Choose Heritage at Deer Valley for a stylish and convenient living experience near Banner Thunderbird Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Banner Thunderbird Medical Center",
      "seo_description": "Discover Heritage at Deer Valley, offering convenient apartments near Banner Thunderbird Medical Center. Ideal for healthcare professionals in Phoenix.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-honorhealth-deer-valley-medical-center",
      "search_query": "apartments close to HonorHealth Deer Valley Medical Center Deer Valley",
      "category": "Hospital",
      "h1_title": "Apartments Close to HonorHealth Deer Valley",
      "h2_subtitle": "Find spacious apartments at Heritage at Deer Valley, located close to HonorHealth Deer Valley Medical Center. Ideal for healthcare staff.",
      "page_copy": "Looking for apartments close to HonorHealth Deer Valley Medical Center? Heritage at Deer Valley offers the perfect living solution for healthcare employees seeking proximity and convenience. Located in the vibrant Deer Valley neighborhood, our community reduces commute times, allowing you to focus on what matters most.\n\nOur exceptional amenities, including a relaxing spa with seating and two tot lots, provide comfort and enjoyment for every resident. Spacious walk-in closets and available additional storage ensure all your belongings find a place, while our resident BBQ areas serve as great spots for communal gatherings. Experience hassle-free living at Heritage at Deer Valley, minutes away from HonorHealth Deer Valley Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HonorHealth Deer Valley Medical Center",
      "seo_description": "Discover convenient living at Heritage Deer Valley, offering apartments close to HonorHealth Deer Valley Medical Center. Ideal for healthcare workers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-sonoran-preserve-phoenix",
      "search_query": "apartments near sonoran preserve phoenix",
      "category": "Park",
      "h1_title": "Apartments Near Sonoran Preserve",
      "h2_subtitle": "Explore Heritage at Deer Valley, located close to Sonoran Preserve, Phoenix's scenic gem. Ideal for nature enthusiasts.",
      "page_copy": "At Heritage at Deer Valley, our apartments are ideally situated near the stunning landscapes of Sonoran Preserve in Phoenix. Perfect for nature lovers, our location offers easy access to scenic hikes and outdoor adventures right at your doorstep.\n\nOur community features numerous amenities designed for your comfort and enjoyment. Relax in the soothing spa or enjoy a day at the tot lots. Ample storage options, including spacious walk-in closets, make organization a breeze, while our resident BBQ areas are perfect for socializing and relaxing. Experience the best of both worlds at Heritage at Deer Valley, where urban living meets natural beauty, only a short drive from Sonoran Preserve.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sonoran Preserve Phoenix",
      "seo_description": "Experience nature and comfort at Heritage Deer Valley, offering apartments near Sonoran Preserve. Enjoy Phoenix's best outdoor activities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "heritage-at-deer-valley-near-thunderbird-conservation-park",
      "search_query": "heritage at deer valley near thunderbird conservation park",
      "category": "Park",
      "h1_title": "Heritage at Deer Valley Near Thunderbird Park",
      "h2_subtitle": "Discover Heritage at Deer Valley, located closely to Thunderbird Conservation Park. Perfect for outdoor enthusiasts seeking nearby nature trails.",
      "page_copy": "Embrace the vibrant lifestyle at Heritage at Deer Valley, conveniently located near Thunderbird Conservation Park in Phoenix. Known for its scenic trails and picturesque landscapes, Thunderbird Conservation Park is an ideal retreat for those who cherish outdoor adventures and nature activities just moments away from home.\n\nOur community offers numerous amenities, including a spa with seating and spacious walk-in closets, providing residents both relaxation and convenience. With two tot lots for the kids and resident BBQ areas, Heritage at Deer Valley is designed to accommodate every aspect of modern family life. Choose a home that complements an active lifestyle and enjoy the beauty of nature with Thunderbird Conservation Park just around the corner.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heritage at Deer Valley Near Thunderbird Park",
      "seo_description": "Live at Heritage Deer Valley, near Thunderbird Conservation Park. Enjoy Phoenix's outdoor beauty with trails and amenities just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166434",
      "source": "generator",
      "page_item_url": "apartments-near-metro-pkwy-phx",
      "search_query": "apartments near metro pkwy phx",
      "category": "Transit",
      "h1_title": "Apartments Near Metro Pkwy Phoenix",
      "h2_subtitle": "Heritage at Deer Valley offers convenient living near Metro Pkwy, Phoenix. An excellent choice for accessible urban amenities.",
      "page_copy": "Discover the convenience of living at Heritage at Deer Valley, offering modern apartments near Metro Pkwy in Phoenix. Ideal for those who enjoy easy access to shopping, dining, and entertainment, our community places you in the heart of Phoenix's vibrant urban scene.\n\nOur community features outstanding amenities such as a relaxing spa with seating and expansive walk-in closets in each apartment. Additional storage is available to meet all your needs, while resident BBQ areas offer a great place to relax and mingle with neighbors. Experience the perfect blend of city life and community living at Heritage at Deer Valley, conveniently located near Metro Pkwy.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Metro Pkwy Phoenix",
      "seo_description": "Find prime living at Heritage Deer Valley, providing apartments near Metro Pkwy Phoenix. Enjoy easy access to shopping, dining, and entertainment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5304"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425431"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=81ed04f0212e11b72aa5f8ef1b3101d76cee01dc9d0f46031b01fd7e04a6d6dae7954537bb385f5fe49b748135a08fb9\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PXWCRN9X"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "93HDV"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40245962057"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Heritage at Deer Valley/scheduletourwidget/Wo7c5xudnCnFHRXL6k/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InA0ZzRTWXZYVmRmQ3hGODFTS3M2NUE9PSIsInZhbHVlIjoiY1FMeitBcHBwajZuWFlvTlhJNHVnQT09IiwibWFjIjoiYWM3OGQwM2U5YzgxYmU0ZDE2NTE3N2IwMjliYTEwZWJkNTllZTdkYTE5ODgxYTRmNDgxMjdkZGFmYTZmNGY4NiJ9"
    }
  ],
  "custom_qb_id": "5304",
  "custom_repli_id": "18104425431",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=81ed04f0212e11b72aa5f8ef1b3101d76cee01dc9d0f46031b01fd7e04a6d6dae7954537bb385f5fe49b748135a08fb9\"></script>",
  "custom_google_gtm_id": "GTM-PXWCRN9X",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "93HDV",
  "custom_hubspot_company_id": "40245962057",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Heritage at Deer Valley/scheduletourwidget/Wo7c5xudnCnFHRXL6k/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InA0ZzRTWXZYVmRmQ3hGODFTS3M2NUE9PSIsInZhbHVlIjoiY1FMeitBcHBwajZuWFlvTlhJNHVnQT09IiwibWFjIjoiYWM3OGQwM2U5YzgxYmU0ZDE2NTE3N2IwMjliYTEwZWJkNTllZTdkYTE5ODgxYTRmNDgxMjdkZGFmYTZmNGY4NiJ9"
};

export const generatedAt = '2026-08-25T19:52:29.311Z';
